export default __webpack_public_path__ + "static/media/navBarImage.d821ab68.png";